import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { TipoFirmante, TipoFirmanteCopiaBasica, TipoFirmanteNifEmitter } from '../../../envios/models/tipo-firmante';
import { ConfiguracionFirma, FirmanteNif } from '../../models/firmante-nif';
import { DatosDocumentosService } from '../../services/datos-documentos.service';
import { FormularioDocumentoService } from '../../services/formulario-documento.service';
import { FormularioValidacionesDocsService } from '../../services/formulario-validaciones-docs.service';
import { DatosConfiguracionDocumentosService } from '../../services/datos-configuracion-documentos.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-configuracion-documento-datos-nif',
  templateUrl: './configuracion-documento-datos-nif.component.html',
  styleUrls: ['./configuracion-documento-datos-nif.component.css']
})
export class ConfiguracionDocumentoDatosNifComponent implements OnInit {

  nif: string = '';
  @Input() tipoFirmante: TipoFirmanteCopiaBasica; //TipoFirmante
  @Input() idPdf: string;
  firmanteDetalle: boolean = false;
  firmanteNifForm: FormGroup = new FormGroup({});
  cargando: boolean = false;
  @Output() anadirFirmanteAdicionalEmitter: EventEmitter<number> = new EventEmitter<number>();
  @Output() cargandoNifSpinnerEmitter: EventEmitter<TipoFirmanteNifEmitter> = new EventEmitter<TipoFirmanteNifEmitter>();
  @Output() eliminarFirmanteEmitter: EventEmitter<any> = new EventEmitter<any>();

  constructor(public formularioDocumentoService: FormularioDocumentoService,
              private fb: FormBuilder,
              public formularioValidacionesDocsService: FormularioValidacionesDocsService,
              private datosDocumentosService: DatosDocumentosService,
              public datosConfiguracionDocumentosService: DatosConfiguracionDocumentosService,
              private _snackBar: MatSnackBar) {
                this.montarFormularioVacio();
               }

  ngOnInit(): void {
    this.inicializaFormularioFirmanteNif();
  }

  get idTipoDocumento(){ return this.formularioDocumentoService.formularioDocumento.controls['idTipoDocumento'] }
  get firmantesNif(){ return this.formularioDocumentoService.formularioDocumento.controls['firmantesNif'] as FormArray}
  get posicionNif(){ return this.firmanteNifForm.controls['posicionNif']}
  get nifPage(){ return this.firmanteNifForm.controls['nifPage']}
  get nifOrden(){ return this.firmanteNifForm.controls['nifOrden']}
  get nifFormulario(){return this.firmanteNifForm.controls['nifFormulario'] }
  get incluirFirmante(){ return this.firmanteNifForm.controls['incluirFirmante']}
  get generico(){return this.formularioDocumentoService.formularioDocumento.controls['generico'] }
  get esCopiaBasica(){return this.formularioDocumentoService.formularioDocumento.controls['esCopiaBasica'] }

  montarFormularioVacio(){
    this.firmanteNifForm = this.fb.group({
      tipoFirmante: [],
      posicionNif: [],
      nifPage: [],
      nifOrden: [],
      nifFormulario:[],
      incluirFirmante:[]
    })
  }

  //si el array de nifs no está vacío, montamos el formulario con estos valores y mostramos el Nif correspondiente
  //si esCopiaBasica true, el firmante principal aparece ya informado con solo check y deshabilitado para que no se pueda eliminar. Si volvemos atrás y deschequeamos copia básica, el firmante principal se elimina y se muestra con la flecha para poder mostarlo y añadir page y orden o formulario.
  inicializaFormularioFirmanteNif(){
    if(this.firmantesNif.value.length > 0){
      this.firmantesNif.value.forEach((x:any, i:number) => {
        if(x.tipoFirmante.codigo == this.tipoFirmante.codigo){
          this.firmanteNifForm = this.fb.group({
            tipoFirmante: [this.tipoFirmante.desc],
            posicionNif:[this.buscarPosicionNif(x.nifOrden, x.nifPage, x.nifFormulario)],
            nifPage: [x.nifPage==0 ? null : x.nifPage],
            nifOrden: [(x.nifOrden==0 && !this.generico.value && !this.esCopiaBasica.value)? null : x.nifOrden],
            nifFormulario:[x.nifFormulario=='' ? null : x.nifFormulario],
            incluirFirmante:[{value: (((this.generico.value || this.esCopiaBasica.value) && x.nifPage==1) || this.tipoFirmante.checkSiCopiaBasica) ? true : false, disabled: this.tipoFirmante.checkSiCopiaBasica}]
          })
          this.firmantesNif.at(i).get('posicionNif').setValue(this.buscarPosicionNif(x.nifOrden, x.nifPage, x.nifFormulario))
          this.firmantesNif.at(i).get('nifPage').setValue(x.nifPage==0 ? null : x.nifPage);
          this.firmantesNif.at(i).get('nifOrden').setValue((x.nifOrden==0 && !this.generico.value && !this.esCopiaBasica.value) ? null : x.nifOrden);
          this.firmantesNif.at(i).get('nifFormulario').setValue(x.nifFormulario=='' ? null : x.nifFormulario)
          if(this.nifPage.value > 0 && this.nifPage.value <= this.formularioDocumentoService.totalPages && this.nifOrden.value > 0){
            this.cargando = true;
            this.muestraNif(this.idPdf, this.nifPage.value, this.nifOrden.value);
            this.incluirFirmante.setValue(true);
          }else{
            this.nif = "";
            this.datosConfiguracionDocumentosService.noExistenNifs[this.obtenerIndexNifArray()] = false;
          }
          if(!this.generico.value && !this.tipoFirmante.checkSiCopiaBasica){
            this.firmanteDetalle = true;
            this.incluirFirmante.setValue(true);
          }
        }
      })
    }else{
      this.firmanteNifForm = this.fb.group({
        tipoFirmante: [this.tipoFirmante.desc],
        posicionNif: [],
        nifPage: [],
        nifOrden: [],
        nifFormulario:[],
        incluirFirmante:[{value: this.tipoFirmante.checkSiCopiaBasica ? true : false, disabled: this.tipoFirmante.checkSiCopiaBasica}]
      })
      if(this.tipoFirmante.checkSiCopiaBasica){
        this.setGenericoOCopiaFirmanteNifForm();
        let valoresFirmanteNif = this.updateValorFirmanteNif();
        this.formularioDocumentoService.addFirmanteNifInFormArray(valoresFirmanteNif)
        this.datosConfiguracionDocumentosService.noExistenNifs[this.obtenerIndexNifArray()] = false;
      }
    }
    //si no hay datos borramos el firmante de FirmantesNif, para que salte el error de no hay firmantes en las validaciones
    if(this.nifPage.value == null && this.nifOrden.value == null && this.nifFormulario.value==null && this.posicionNif.value==null){
      let indexBorrar = this.firmantesNif.value.findIndex(x=>x.tipoFirmante.desc==this.firmanteNifForm.value.tipoFirmante)
      if(indexBorrar>-1){
        this.formularioDocumentoService.deleteFirmanteNifInFormArray(this.firmantesNif.at(indexBorrar).value)
      }
    }
  }

  buscarPosicionNif(nifOrden: number, nifPage: number, nifFormulario:string):string{
    if(nifOrden || nifPage) return 'pagina'
    if(nifFormulario) return 'formulario'
    return null
  }

  mostrarDetalle(){
    this.firmanteDetalle = !this.firmanteDetalle;
    if(!this.incluirFirmante.value){
      this.incluirFirmante.setValue(true);
      let valoresFirmanteNif = this.resetValorFirmanteNif();
      this.formularioDocumentoService.addFirmanteNifInFormArray(valoresFirmanteNif);
      if(Number(this.tipoFirmante.codigo)>102) this.anadirFirmanteAdicionalEmitter.emit(Number(this.tipoFirmante.codigo)+1);
    }
  }

  obtenerIndexNifArray():number{
    return this.formularioDocumentoService.firmantesNif.value.findIndex((x:FirmanteNif) => x.tipoFirmante.codigo == this.tipoFirmante.codigo)
  }

  muestraNif(id:string, nifPage:number, nifOrden:number){
    this.cargandoNifSpinnerEmitter.emit({firmante: this.tipoFirmante.desc, cargando: true});
    this.traeNif(id, nifPage, nifOrden).then(
      value => {
        this.nif = value;
        this.datosConfiguracionDocumentosService.noExistenNifs[this.obtenerIndexNifArray()] = false;
        this.cargando = false;
        this.cargandoNifSpinnerEmitter.emit({firmante: this.tipoFirmante.desc, cargando: false});
      },
      error => {
        console.error(error);
        this.cargando = false;
        this.cargandoNifSpinnerEmitter.emit({firmante: this.tipoFirmante.desc, cargando: false});
        this.datosConfiguracionDocumentosService.noExistenNifs[this.obtenerIndexNifArray()] = true;
        this.nif = "";
      }
    )
  }

  async traeNif(id:string, pagina:number, orden:number): Promise<string>{
    return await this.datosDocumentosService.traeNif(id, pagina, orden).toPromise();
  }

  borrarInputContrario(tipo:string){
    if(tipo=='pagina'){
      this.posicionNif.setValue('pagina');
      this.nifFormulario.setValue(null);
    }
    if(tipo=='formulario'){
      this.posicionNif.setValue('formulario');
      this.nifPage.setValue(null);
      this.nifOrden.setValue(null);
      this.nif='';
    }
    let valoresFirmanteNif = this.updateValorFirmanteNif();
    this.formularioDocumentoService.addFirmanteNifInFormArray(valoresFirmanteNif);
  }

  tipoClickGenerico:string='';
  getClickCheckboxGenerico(tipo:string){
    this.tipoClickGenerico=tipo;
      this.incluirFirmante?.valueChanges.subscribe(value => {
        if(this.tipoClickGenerico!==''){
          if(value){
            this.setGenericoOCopiaFirmanteNifForm();
            let valoresFirmanteNif = this.updateValorFirmanteNif();
            this.formularioDocumentoService.addFirmanteNifInFormArray(valoresFirmanteNif)
            this.datosConfiguracionDocumentosService.noExistenNifs[this.obtenerIndexNifArray()] = false;
            if(Number(valoresFirmanteNif.tipoFirmante.codigo)>102) this.anadirFirmanteAdicionalEmitter.emit(Number(valoresFirmanteNif.tipoFirmante.codigo)+1); //emitimos para añadir el siguiente firmante.
          }else{
            this.resetFirmanteNifForm();
            let valoresFirmanteNif = this.resetValorFirmanteNif();
            this.formularioDocumentoService.deleteFirmanteNifInFormArray(valoresFirmanteNif);
            this.eliminarFirmanteEmitter.emit();
          }
          this.tipoClickGenerico='';
        }
      })
  }

  tipoClickNoGenerico:string='';
  getClickCheckboxNoGenerico(tipo:string){
    this.tipoClickNoGenerico=tipo;
    this.incluirFirmante?.valueChanges.subscribe(value => {
      if(this.tipoClickNoGenerico!==''){
        let valoresFirmanteNif = this.resetValorFirmanteNif();
        this.posicionNif.setValue(null);
        if(value){
          this.firmanteDetalle=true;
          this.formularioDocumentoService.addFirmanteNifInFormArray(valoresFirmanteNif);
          if(Number(valoresFirmanteNif.tipoFirmante.codigo)>102) this.anadirFirmanteAdicionalEmitter.emit(Number(valoresFirmanteNif.tipoFirmante.codigo)+1);
        }else{
          this.resetFirmanteNifForm();
          this.firmanteDetalle=false;
          this.nif='';
          this.formularioDocumentoService.deleteFirmanteNifInFormArray(valoresFirmanteNif);
          this.eliminarFirmanteEmitter.emit();
        }
        this.datosConfiguracionDocumentosService.noExistenNifs[this.obtenerIndexNifArray()] = false;
        this.tipoClickNoGenerico='';
      }

    })
  }

  anadirValoresNif(){
    let valoresFirmanteNif = this.updateValorFirmanteNif();
    this.formularioDocumentoService.addFirmanteNifInFormArray(valoresFirmanteNif); //añadimos los valores en el formularioDocumento para que haga las validaciones
    this.nif=''; //le borramos en nif si lo hubiera en el caso que hayamos borrado nifPage o nifOrden
    if(this.nifPage.value > 0 && this.nifPage.value <= this.formularioDocumentoService.totalPages && this.nifOrden.value > 0){
      this.cargando = true;
      this.muestraNif(this.idPdf, this.nifPage.value, this.nifOrden.value);
    }
  }

  // renameFirmantes(firmantesNif: FirmanteNif[]): any[] {
  //   let minCodigo = 103;
  //   let adicionales = firmantesNif.filter(x => x.tipoFirmante.desc.includes('Firmante adicional'));
  //   // ordenamos según código, el '+' los convierte en números en vez de string
  //   adicionales.sort((a, b) => +a.tipoFirmante.codigo - +b.tipoFirmante.codigo);
  //   // asignamos los nuevos códigos por orden
  //   for (let firmante of adicionales) {
  //     firmante.tipoFirmante.codigo = minCodigo.toString();
  //     firmante.tipoFirmante.desc = `Firmante adicional ${minCodigo - 102}`;
  //     minCodigo++;
  //   }
  //   return firmantesNif;
  // }

  setGenericoOCopiaFirmanteNifForm(){
    this.posicionNif.setValue('pagina');
    this.nifOrden.setValue(0);
    this.nifPage.setValue(1);
    this.nifFormulario.setValue(null);
  }

  resetFirmanteNifForm(){
    this.posicionNif.setValue(null);
    this.nifOrden.setValue(null);
    this.nifPage.setValue(null);
    this.nifFormulario.setValue(null);
  }

  resetValorFirmanteNif():FirmanteNif{
    let valoresFirmanteNif: FirmanteNif;
    valoresFirmanteNif = {
      tipoFirmante: {
        codigo: this.tipoFirmante.codigo,
        desc: this.tipoFirmante.desc
      },
      nifPage: null,
      nifOrden: null,
      firmas: {} as ConfiguracionFirma,
      formularios: [],
      camposEditables: [],
      nifFormulario:null,
      posicionNif: null
    }
    return valoresFirmanteNif
  }

  updateValorFirmanteNif():FirmanteNif{
    let valoresFirmanteNif: FirmanteNif;
    valoresFirmanteNif = {
      tipoFirmante: {
        codigo: this.tipoFirmante.codigo,
        desc: this.tipoFirmante.desc
      },
      nifPage: this.firmanteNifForm.controls['nifPage'].value,
      nifOrden: this.firmanteNifForm.controls['nifOrden'].value,
      firmas: {} as ConfiguracionFirma,
      formularios: [],
      camposEditables: [],
      nifFormulario:this.firmanteNifForm.controls['nifFormulario'].value,
      posicionNif: this.firmanteNifForm.controls['posicionNif'].value
    }
    return valoresFirmanteNif
  }



}
